import { render } from "./Security2fa.vue?vue&type=template&id=fcc24192"
import script from "./Security2fa.vue?vue&type=script&lang=js"
export * from "./Security2fa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__